import React from 'react';
import { FormSection } from '../../common/FormSection';
import { FormInput } from '../../common/FormInput';
import { FormCheckboxGroup } from '../../common/FormCheckboxGroup';
import { BehaviourSupportPlanData } from 'src/models/form-types';

interface PurposeSectionProps {
  formData: BehaviourSupportPlanData;
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCheckboxChange: (name: string, checked: boolean, category: keyof BehaviourSupportPlanData) => void;
  className?: string;
}

// Define the purpose options
const purposeOptions = [
  {
    id: 'purpose-diagnosis',
    name: 'Student with a confirmed diagnosis and functional impact',
    label: 'Student with a confirmed diagnosis and functional impact',
  },
  {
    id: 'purpose-oohc',
    name: 'Student is in Out of Home Care (OoHC)',
    label: 'Student is in Out of Home Care (OoHC)',
  },
  {
    id: 'purpose-social',
    name: 'Student is experiencing significant social/emotional difficulties',
    label: 'Student is experiencing significant social/emotional difficulties',
  },
  {
    id: 'purpose-ifs',
    name: 'Student receives Integration Funding Support (IFS)',
    label: 'Student receives Integration Funding Support (IFS)',
  },
  {
    id: 'purpose-academic',
    name: 'Student is experiencing significant academic difficulties',
    label: 'Student is experiencing significant academic difficulties',
  },
  {
    id: 'purpose-oppositional',
    name: 'Student is regularly exhibiting oppositional or defiant behaviours',
    label: 'Student is regularly exhibiting oppositional or defiant behaviours',
  },
];

export const PurposeSection: React.FC<PurposeSectionProps> = ({ 
  formData, 
  onTextChange, 
  onCheckboxChange, 
  className 
}) => {
  const handleCheckboxChange = (name: string, checked: boolean) => {
    onCheckboxChange(name, checked, 'purpose');
  };

  return (
    <FormSection title="Purpose *" className={className}>
      <FormCheckboxGroup
        options={purposeOptions}
        selectedValues={formData.purpose}
        onChange={handleCheckboxChange}
      />
      
      <FormInput
        id="otherPurpose"
        name="otherPurpose"
        label="Other:"
        value={formData.otherPurpose}
        onChange={onTextChange}
      />
    </FormSection>
  );
};
